import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'translate'
})
export class TranslatePipe implements PipeTransform {
  transform(value: string) {
    if (value === 'attended') {
      return 'asistida'
    }
    if (value === 'reserved') {
      return 'reservada'
    }
    if (value === 'not_attended') {
      return 'no asistida'
    }
    if (value === 'subscription'){
      return 'membresía'
    }
    if (value === 'noshow') {
      return 'no-show'
    }
    else{
      return value
    }
  }
}



// WEBPACK FOOTER //
// ./src/pipes/translate.ts